import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import React from 'react';
import { styles } from './TableOfContents.css';
import { Link } from '../PlatformFunctionality';

export interface TableOfContentsProps {
  heading: string;
  items: Array<{ label: string; href: string }>;
}

export const TableOfContents = ({ heading, items }: TableOfContentsProps) => {
  return (
    <div className={styles.wrapper}>
      <DomFont as="h3" className={styles.heading}>
        {heading}
      </DomFont>
      <ul className={styles.list}>
        {items.map(item => (
          <li className={styles.listItem} key={item.href}>
            <Link className={styles.link} href={item.href}>
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
